// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".PZy8{display:flex;max-width:93rem;padding:1.6rem 0;margin:0 auto;border-width:0;border-bottom:1px solid #e3e3e3}@media (max-width:61.9375em){.PZy8{flex-direction:column}}.Wg4Q{width:27rem}._3E_0{flex:1}@media (min-width:62em){._3E_0 .ui-input-el,._3E_0 button,._3E_0 input,._3E_0 select,._3E_0 textarea{max-width:37rem}}", ""]);
// Exports
exports.locals = {
	"root": "PZy8",
	"label": "Wg4Q",
	"fields": "_3E_0"
};
module.exports = exports;
